import { useQuery } from '@tanstack/react-query';
import { ServiceFactory } from '../../../../services/ServiceFactory';

interface UseComplaintsParams {
  complaintsPerPage?: number,
  pageIndex?: number
}

/**
 * Hook for fetching all complaints of the user
 */
export const useComplaints = ({ complaintsPerPage = 0, pageIndex = 0 }: UseComplaintsParams = {}) => {
  const complaintsService = ServiceFactory.createComplaintsService();

  const { data, status, isRefetching } = useQuery({
    queryKey: ['complaints', `page ${pageIndex}`],
    queryFn: () => complaintsService.getComplaints({ perPage: complaintsPerPage, pageIndex }),
  });

  return {
    complaints: data?.results || [],
    total: data?.total || 0,
    status,
    isRefetching,
  };
};

/**
 *  Hook for fetching a single complaint
 * @param {*} id
 * @returns
 */
export const useComplaint = (id = '') => {
  const complaintsService = ServiceFactory.createComplaintsService();

  const { data: complaint, status, isRefetching } = useQuery({
    queryKey: ['complaint', id],
    queryFn: () => complaintsService.getComplaint(id),
  });

  return {
    complaint,
    status,
    isRefetching,
  };
};
